import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useDeviceType } from '../../../responsive';
import { useControlledValue } from '../../internal';
import { SelectMobile } from '../SelectMobile';
import { SelectDesktop } from '../SelectDesktop';

/**
 * Адаптивный select-компонент для выбора одного значения из списка
 *
 * * Десктопный вариант открывает выпадающий список
 * * Мобильный вариант открывает список в модальном окне
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var Select = /*#__PURE__*/React.forwardRef(function Select(props, ref) {
  var deviceType = useDeviceType();
  var _useControlledValue = useControlledValue(props, null),
    value = _useControlledValue.value,
    onChange = _useControlledValue.onChange;
  if (deviceType === 'phone') {
    return /*#__PURE__*/_jsx(SelectMobile, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      value: value,
      onChange: onChange
    }));
  }
  return /*#__PURE__*/_jsx(SelectDesktop, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    value: value,
    onChange: onChange
  }));
});